/** @jsx jsx */
import { jsx } from 'theme-ui';
import { theme, useConfig, ComponentsProvider } from 'docz';
import { Styled, ThemeProvider } from 'theme-ui';
import defaultTheme from '~theme';
import components from '~components';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Theme = function Theme(_ref) {
  var children = _ref.children;
  var config = useConfig();
  return jsx(ThemeProvider, {
    theme: config.themeConfig
  }, jsx(ComponentsProvider, {
    components: components
  }, jsx(Styled.root, null, children)));
};

var __DOCZ_DUMMY_EXPORT_DEFAULT = theme(defaultTheme)(Theme);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-theme-docz/src/index.js"
    }
  });
}